import { Injectable, signal } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { UserPrefBLListType } from 'src/app/shared/models/core';
import { FavouriteListAPIModel, UserPreference, FavBloms } from 'src/app/shared/models/favourite';
import { ConnectionService } from 'src/app/shared/services/connection/connection.service';

import { FavouriteListPayload } from 'src/app/shared/entity/utility-interfaces';
import { UserPreferenceEnum } from './setting/setting.component';
import { DeleteListPaylaod, UserPreferencesService } from 'src/app/shared/services/user-preferences/user-preferences.service';
import { PreferenceResponseModel } from 'src/app/shared/models/preference';

@Injectable({
  providedIn: 'root'
})
export class SettingService {

  favoriteForm: FormGroup = new FormGroup({
    name: new FormControl(''),
    blList: new FormControl([]),
    id: new FormControl('')
  });

  selectedBusinessLocation: FavBloms[] = [];
  private readonly favoriteListsState = signal<FavouriteListAPIModel[]>([]);
  readonly favListArray = this.favoriteListsState.asReadonly();
  readonly blList = signal<FavBloms[]>([]);
  favlist:FavouriteListAPIModel[];
  blListType={
    eveningRoute: UserPrefBLListType.eveningRoute,
    taskBankUPP: UserPrefBLListType.taskbankUPP
  }

  formPopupVisible = false;

  constructor(
    private formBuilder: FormBuilder,
    private connectionService:ConnectionService,
    private messageService: MessageService,
    private userPreferenceService :UserPreferencesService
  ) { }

  createForm() {
    // creating the favList Form.
    this.favoriteForm = this.formBuilder.group({
      name: ['', [Validators.required]],
      blList: [[], [Validators.required]],
      id: ['']
    });
  }

  setFormValue(favlist: FavouriteListAPIModel) {
    this.createForm();
    // setting up the database value for the form.
    this.favoriteForm.controls['name'].setValue(favlist.name);
    this.favoriteForm.controls['id'].setValue(favlist.id);
    
    this.favoriteForm.controls['blList'].setValue(favlist.blids);
  }

  submit() {
    const favObject: FavouriteListAPIModel=
      {
      name: this.favoriteForm.value.name,
      blids: this.favoriteForm.value.blList,
      id: !this.favoriteForm.value.id ? crypto.randomUUID() : this.favoriteForm.value.id,
      };
    
    this.userPreferenceService.saveUserPreference(UserPreferenceEnum.FAVORITE_LIST,favObject).subscribe({
      next: () => {
        const messages = `Favourite List is ${!this.favoriteForm.value.id ? 'created' : 'updated'} successfully!`
        this.getFavList();
        this.formPopupVisible = false;
        this.messageService.add({ severity: 'success', summary: 'Success', detail: messages });
      },
      error: () => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Network Error! Please try again.' });
      }
    });

  }

  /**
   * 
   * This method is called when user clicks confirm delete for favorite list.
   * Delete request is sent to backend API, upon successful deletion, success message is displayed.
   */
  deleteFavList(favData: FavouriteListPayload) {
    const payload: DeleteListPaylaod = 
    { preferenceKey: UserPreferenceEnum.FAVORITE_LIST, id: favData.id }
    this.userPreferenceService.deleteUserPreference(payload).subscribe({
      next: () => {
        this.getFavList();
        this.formPopupVisible = false;
        const messages = `Favourite list ${favData.name} is deleted successfully!`
        this.messageService.add({ severity: 'success', summary: 'Success', detail: messages });
      },
      error: () => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Network Error! Please try again.' });
      }
    });
  }

  getUserPreferencePayload(favObject: FavouriteListAPIModel) {
    const userPreference: UserPreference = {
      business_locations:[]
    }
    userPreference.business_locations.push(favObject);
    return userPreference;
  }

   /**
   * This method is called when clicks on settings to get all the Preferences data.
   * and when user add, updates or delete any preference.
   */
   getFavList() {
    this.userPreferenceService.getUserPreferenceByKey(UserPreferenceEnum.FAVORITE_LIST).subscribe({
        next: (response: PreferenceResponseModel) => {
          const responseBody: FavouriteListAPIModel[] = response?.preferenceValue ? JSON.parse(response.preferenceValue) : [];
          this.favoriteListsState.set(responseBody);
        }
      });
  }

  get formValue() {
    return this.favoriteForm.controls;
  }
}
